import apiService from "../common/commonApi";

export const employee = {};

employee.list = async (param) => {    
    return apiService.Get('employee-list', param);
}

employee.add = async (param) => {    
    return apiService.Post('employee-create', param);
}

employee.update = async (param) => {    
    return apiService.Post('employee-update', param);
}

employee.delete = async (param) => {    
    return apiService.Post('employee-delete', param);
}
